export const Miniplus = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6673 8.66634H8.66732V12.6663H7.33398V8.66634H3.33398V7.33301H7.33398V3.33301H8.66732V7.33301H12.6673V8.66634Z"
      fill="#007EFF"
    />
  </svg>
);
